<template>
<div id="overview">
  <div class="small_screens">
    Sorry, but App Analytics service currently works only with large displays (1250px and wider).
  </div>
  <div class="big_screens">
    <modal
          name="formulas-view"
          :adaptive="true"
          classes="formulasModal"
          height="55%"
          width="50%"
    >
      <Formulas :hide="hideFormulas" />
    </modal>

    <!-- SELECT LINE1 -->
    <div class="select-line1">

      <!-- BUNDLES -->
      <div class="s-bundles">
        <div
              class="bundle"
              v-for="(bundle, id) in availableBundles"
              :key="id"
              @click=toggleSelectBudle(bundle.bundleId)
              :class="{active: selectedBundles.indexOf(bundle.bundleId) != -1}"
              @mouseover="showTip(bundle, id)"
              @mouseleave="hideTip(bundle)"
        >
          <div
                class="bundle-info"
                :class="{show: bundle.tipShown}"
                v-on:click.stop
          >
            <div> Title: {{bundle.title}}</div>
            <div> Bundle: {{bundle.bundleId}}</div>
            <div> AppStore link: <a
                    :href="bundle.url"
                    target="_blank"
              ><i class="fas fa-external-link-alt"></i></a></div>
          </div>
          <img
                class="applogo"
                :src="bundle.logo"
                alt="app image"
          >
        </div>
      </div>

      <!-- <multiselect
          :multiple="true"
          :searchable="false"
          @close="onBundlesSelectClose"
          :close-on-select="false"
          class="select-project"
          :class="{pending : bundlesPending()}"
          v-model="selectedBundles"
          :options="availableBundles"
          :allow-empty="false"
          :option-height="40"
          :show-labels="false"
    >
      <template
            slot="tag"
            slot-scope="{ option, remove }"
      >
        <span
              class="custom__tag applogo-container"
              @mousedown.prevent
        >
          <img
                class="applogo"
                :src="projectsByBundle[option].logo"
                width="40"
                alt="app image"
          >
          <div
                class="custom__remove remove"
                @click="onRemoveBundleWrapper(remove,option)"
          >
            <span class="cross">&#10006;</span>
          </div>
        </span>
      </template>

      <template
            slot="option"
            slot-scope="props"
      >
        <div class="inline">
          <img
                :src="projectsByBundle[props.option].logo"
                width="40"
                alt="app image"
          >
          <div>
            <span>
              &nbsp;&nbsp;{{ projectsByBundle[props.option].title }}
            </span>
          </div>
        </div>
      </template>
    </multiselect> -->


      <!-- STATIC DATA -->
      <div class="static_wrap">
        <div
              class="static_data"
              v-if="!loadingTable"
        >
          <div class="static">
            <div class="static_pair">
              <span class="static_header">Active Trials <i class="fas fa-question">
                  <div class="tooltiptext">
                    Number of currently active trials for selected apps.
                  </div>
                </i></span>
              <div class="static_number">
                {{staticData.trials}}
              </div>
            </div>
          </div>
          <div class="static">
            <div class="static_pair">
              <span class="static_header">Active Introductory <i class="fas fa-question">
                  <div class="tooltiptext">
                    Number of currently active subscriptions in introductory period for selected apps.
                  </div>
                </i></span>
              <div class="static_number">
                {{staticData.intro}}
              </div>
            </div>
          </div>
          <div class="static">
            <div class="static_pair">
              <span class="static_header">Active Offers <i class="fas fa-question">
                  <div class="tooltiptext">
                    Number of currently active promotional offers for selected apps.
                  </div>
                </i></span>
              <div class="static_number">
                {{staticData.offers}}
              </div>
            </div>
          </div>
          <div class="static">
            <div class="static_pair">
              <span class="static_header">Active Subscriptions <i class="fas fa-question">
                  <div class="tooltiptext">
                    Number of currently active regular subscriptions for selected apps.
                  </div>
                </i></span>
              <div class="static_number">
                {{staticData.subs}}
              </div>
            </div>
            <div class="static_pair">
              <div class="static_subs">
                app.weekly: <span class="number">{{staticData.sWeekly}}</span><br>
                app.monthly: <span class="number">{{staticData.sMonthly}}</span><br>
                app.yearly: <span class="number">{{staticData.sYearly}}</span>
              </div>
            </div>
          </div>
          <div class="static last">
            <div class="static_pair">
              <span class="static_header">In Billing Retry Period <i class="fas fa-question">
                  <div class="tooltiptext">
                    Number of subscriptions that are currently in Billing Retry Period.
                  </div>
                </i></span>
              <div class="static_number">
                {{staticData.retry}}
              </div>
            </div>
            <div class="static_pair">
              <div class="static_subs">
                app.weekly: <span class="number">{{staticData.rWeekly}}</span><br>
                app.monthly: <span class="number">{{staticData.rMonthly}}</span><br>
                app.yearly: <span class="number">{{staticData.rYearly}}</span>
              </div>
            </div>
          </div>
        </div>
        <div
              class="static_loading"
              v-if="loadingTable"
        >
          <half-circle-spinner
                :animation-duration="1000"
                :size="40"
                :color="'#2DADFC'"
          />
        </div>
      </div>

    </div>



    <div
          class="select-line2"
          id="navbar"
    >
      <!-- csv btn -->
      <button
            class="btn-icon download"
            @click="downloadCSVRef"
            :class="{disabled: !filtersSelected}"
      >
        <i class="fas fa-file-download"></i>
        Download
      </button>
      <!-- formulas btn -->
      <button
            class="btn-icon"
            type="button"
            name="button"
            @click="showFormulas"
      >
        <i class="fas fa-calculator"></i>
        Calculate
      </button>

      <div class="s-events-wrap">
        <span class="events-label">Events:</span>
        <ComfySelect
              class="select-events"
              v-model="events"
              label="Events:"
              :ontoggle="alterEvent"
        />
      </div>

      <!-- COHORT & SANDBOX -->
      <div class="select-cohort">
        <CheckboxToggle
              v-model="cohort"
              :ontoggle="applyFiltersRef"
              v-if="cohort!=null"
              show-labels
              label-checked="cohort"
              label-unchecked="cohort"
        />

        <CheckboxToggle
              v-model="sandbox"
              :ontoggle="applyFiltersRef"
              show-labels
              label-checked="sandbox"
              label-unchecked="sandbox"
        />
      </div>

      <!-- DATES -->
      <div class="dates">
        <date-range-picker
              ref="picker"
              opens="left"
              :ranges="dateRanges"
              :localeData="localeData"
              :maxDate="maxDate"
              :showDropdowns="true"
              :autoApply="false"
              v-model="dates"
              :linkedCalendars="true"
              :timePicker="true"
              :timePicker24Hour="true"
              :alwaysShowCalendars="false"
              :onToggleOpen="refreshDates"
              :toggleOnHover="false"
        >
          <template
                v-slot:input="picker"
                style="min-width: 350px;"
          >
            <i class="far fa-calendar-alt"></i>
            <span
                  class="date-displayed"
                  v-if="picker.rangeLabel != 'Custom range'"
            >
              {{picker.rangeLabel}}
            </span>
            <span
                  class="date-displayed"
                  v-else
            > {{picker.startDate | date}} - {{picker.endDate | date }}</span>
          </template>
        </date-range-picker>
      </div>

      <!-- APPLY FILTERS BUTTON -->
      <div class="apply-container">
        <button
              type="button"
              class="btn-apply"
              @click="applyFiltersRef"
              :class="{pending: stateIsPending}"
        >
          {{stateIsPending ? 'Update':'Refresh'}}
        </button>
      </div>
    </div>

    <!-- FEATURES TABLE -->
    <FeaturesTable
          v-if="this.features.length !=0"
          :loading="loadingTable"
          :onApplyFilters="onApplyFilters"
          :onFiltersSelect="onFiltersSelect"
          :onAttributeSelect="onAttributeSelect"
          :onMarkAction="onMarkAction"
          ref="fTableComponent"
    />

    <!-- CHART -->
    <div class="chart-wrapper">
      <Loader
            :loading="loadingChart"
            color="#FC9401"
      />

      <div class="chart-settings">
        <div
              v-for="(group,id) in eventsGroup"
              :key="id"
              class="event-checkbox"
        >
          <!-- :style="StylesForEventOverview(group.name)" -->
          <input
                type="checkbox"
                v-model="group.shown"
                v-on:change="filterChart"
          >

          <div
                class="circle"
                :style="StylesForEventSelect(group.name)"
          >
          </div>

          -

          {{group.name}}{{(group.name == "expense" || group.name == "revenue") ? "$" : ""}}
        </div>
        <div class="select-precision-wrap">
          <span>Precision:</span>
          <multiselect
                v-model="precision"
                class="select-precision"
                @select="onPrecisionSelect"
                :options="availablePrecisions"
                placeholder="Chart precision"
                :allow-empty="false"
                selectLabel=""
                deselectLabel=""
          />
        </div>
      </div>

      <div class="charts">
        <GChart
              v-if="chartData.length!=0"
              type="ColumnChart"
              :data="chartData"
              :options="chartOptions"
              ref="gChart"
              class="chart-events"
        />
      </div>

    </div>
    <!-- <div class="leave_email">
      <span class="get_in_touch">{{!submitted ? "Leave email and we will get in touch soon" : "Thank you!"}}</span>
      <input
            type="leave_email"
            name=""
            value=""
            v-model="email"
            placeholder="johndoe@google.com"
            v-if="!submitted"
      >
      <button
            type="button"
            name="button"
            class="submit_email"
            @click="submitEmail"
            v-if="!submitted"
      >Submit</button>
    </div> -->
  </div>
</div>
</template>

<script>
import FeaturesTable from '@/components/FeaturesTable.vue';
import API from '@/resources/API.js';
import moment from 'moment-timezone'
import HelpersRes from '@/helpers/Helpers.js';
import Multiselect from 'vue-multiselect'
import Loader from '@/components/Loader.vue'
import ComfySelect from '@/components/ComfySelect.vue'
import CheckboxToggle from '@/components/CheckboxToggle.vue'
import DateRangePicker from 'vue2-daterange-picker'
import store from "@/store/store.js"
import Formulas from '@/components/Formulas.vue';
import {
  HalfCircleSpinner
} from 'epic-spinners'

export default {
  name: 'Overview',
  components: {
    FeaturesTable,
    HalfCircleSpinner,
    Multiselect,
    Loader,
    DateRangePicker,
    ComfySelect,
    CheckboxToggle,
    Formulas
  },

  filters: {
    date(value) {
      if (!value)
        return ''

      let options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      };
      return Intl.DateTimeFormat('en-US', options).format(value)
    }
  },
  watch: {
    // features: {
    //   handler: function(newVal) {
    //     this.featuresToRequest = this.createFeaturesToRequest(newVal)
    //   },
    //   immediate: true,
    // },
    sSandbox: {
      handler: function(newVal) {
        this.sandbox = newVal
      },
      immediate: true,
    },
    sPrecision: {
      handler: function(newVal) {
        this.precision = newVal
      },
      immediate: true,
    },
    sCohort: {
      handler: function(newVal) {
        this.cohort = newVal
      },
      immediate: true,
    },
    sFilter: {
      handler: function(newVal) {
        this.filter = newVal
      },
      immediate: true,
    },
    sDates: {
      handler: function(newVal) {
        this.dates = JSON.parse(JSON.stringify(newVal))
      },
      immediate: true,
    },
    sSelectedBundles: {
      handler: function(newVal) {
        this.selectedBundles = JSON.parse(JSON.stringify(newVal))
      },
      immediate: true,
    }
  },
  computed: {
    featuresToRequest() {
      var featuresToRequest = []
      for (var i = 0; i < this.features.length; i++) {
        if (this.features[i].toAdd || this.features[i].isPresent && !this.features[i].toRemove) {
          featuresToRequest.push(this.features[i].name)
        }
      }
      return featuresToRequest
    },
    stateIsPending() {

      if (this.bundlesPending()) return true

      if (this.dateIsPending()) return true

      if (store.state.events.some(v => {
          return v.toAdd
        })) return true

      if (this.attributesSelected) return true

      if (this.activeFiltersSelected) return true

      if (this.filtersSelected) return true

      return false
    },
    activeFilters() {
      var activeFilters = []
      for (var key of Object.keys(store.state.filter)) {
        var j = activeFilters.push({
          remove: false,
          fName: key,
          fValues: [],
          unfold: false,
        })

        for (var i = 0; i < store.state.filter[key].length; i++) {
          activeFilters[j - 1].fValues.push({
            remove: false,
            value: store.state.filter[key][i],
          })
        }
      }

      return activeFilters
    },
    // maxDate() {
    //   return store.state.maxDate
    // },
    // dateRanges() {
    //   return store.state.dateRanges
    // },
    sSandbox() {
      return store.state.sandbox
    },
    sPrecision() {
      return store.state.precision
    },
    sCohort() {
      return store.state.cohort
    },
    sFilter() {
      return store.state.filter
    },
    sDates() {
      return store.state.dates
    },
    sSelectedBundles() {
      return store.state.selectedBundles
    },
    sFormulas() {
      return store.state.formulas
    },
    eventsToRequest() {
      var eventsToRequest = []
      for (var i = 0; i < this.events.length; i++) {
        if (this.events[i].toAdd || this.events[i].isPresent && !this.events[i].toRemove) {
          eventsToRequest.push(this.events[i].name)
        }
      }
      return eventsToRequest
    },
    features() {
      return store.state.features
    },
    events() {
      return store.state.events
    },
    availableBundles() {
      var bundles = []
      store.state.projects.forEach(project => {
        bundles.push({
          ...project,
          tipShown: false,
          timer: {},
        })
      })
      return bundles
    },
    projectsByBundle() {
      let projectsByBundle = {}
      store.state.projects.forEach(project => {
        projectsByBundle[project.bundleId] = project
      })
      return projectsByBundle
    },
  },

  data() {
    return {
      // featuresToRequest: [],
      submitted: false,
      email: "",
      hoveredBundleId: -1,
      activeFiltersSelected: false,
      attributesSelected: false,
      filtersSelected: false,
      dates: {},
      selectedBundles: [],
      testDates: {
        startDate: Date.now(),
        endDate: Date.now(),
        rangeLabel: "Today",
      },
      localeData: {
        direction: 'ltr',
        format: 'mm/dd/yyyy HH:MM',
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        firstDay: 1
      },
      dateRanges: HelpersRes.dateRanges(),
      maxDate: HelpersRes.maxDate(),
      availablePrecisions: ["day", "week", "month", "year"],
      loadingTable: false,
      loadingChart: false,
      chartData: [],
      eventsGroup: {},
      chartOptions: {
        // title: 'events',
        legend: 'none',
        hAxis: {
          viewWindowMode: 'explicit',
          viewWindow: {
            //max: 180,
            min: 0,
          },
          gridlines: {
            count: 10,
          }
        },
        isStacked: true,
        animation: {
          duration: 500,
          easing: "out"
        },
        chartArea: {
          left: 80,
          top: 40,
          width: "90%",
          height: "80%"
        },
      },
      staticData: {
        trials: 54,
        intro: 17,
        offers: 23,
        subs: 385,
        sWeekly: 143,
        sMonthly: 224,
        sYearly: 18,
        retry: 118,
        rWeekly: 16,
        rMonthly: 102,
        rYearly: 0,
      }
    }
  },

  mounted() {
    var navbar = document.getElementById("navbar");
    var sticky = navbar.offsetTop;

    window.document.onscroll = () => {
      if (window.pageYOffset >= sticky) {
        navbar.classList.add("sticky")
      } else {
        navbar.classList.remove("sticky");
      }
    }

    if (this.$route.params.state_id == "default") {
      this.requestTableData()
        .then(() => {
          return this.requestChartData()
        })
        .catch(() => {})
    } else {
      this.getState(this.$route.params.state_id)
        .then(() => {
          return this.requestTableData()
        })
        .then(() => {
          return this.requestChartData()
        })
        .catch(() => {})
    }
  },
  methods: {
    refreshDates() {
      this.maxDate = HelpersRes.maxDate()
      this.dateRanges = HelpersRes.dateRanges()
      if (this.dates.rangeLabel != "Custom range") {
        this.dates.startDate = this.dateRanges[this.dates.rangeLabel][0].toString()
        this.dates.endDate = this.dateRanges[this.dates.rangeLabel][1].toString()
      }
    },
    submitEmail() {
      amplitude.getInstance().logEvent("test");
      amplitude.setUserId(this.email);
      amplitude.setUserProperties({
        email: this.email
      });

      this.submitted = true
    },
    showTip(bundle, bundleId) {
      this.hoveredBundleId = bundleId
      var vm = this
      bundle.timer = setTimeout(function() {
        if (vm.hoveredBundleId == bundleId) {
          bundle.tipShown = true
          vm.$forceUpdate()
        }
      }, 1000);
    },
    hideTip(bundle) {
      bundle.tipShown = false
      this.hoveredBundleId = -1
      this.$forceUpdate()
    },
    toggleSelectBudle(bundleId) {
      let indx = this.selectedBundles.indexOf(bundleId)
      if (indx == -1) {
        this.selectedBundles.push(bundleId)
      } else {
        this.selectedBundles.splice(indx, 1)
      }
    },
    // featuresToRequest(features) {
    //   var featuresToRequest = []
    //   for (var i = 0; i < features.length; i++) {
    //     if (features[i].toAdd || features[i].isPresent && !features[i].toRemove) {
    //       featuresToRequest.push(features[i].name)
    //     }
    //   }
    //   return featuresToRequest
    // },
    createFeaturesToRequest(features) {
      var featuresToRequest = []
      for (var i = 0; i < features.length; i++) {
        if (features[i].toAdd || features[i].isPresent && !features[i].toRemove) {
          featuresToRequest.push(features[i].name)
        }
      }
      return featuresToRequest
    },
    activeFiltersToRemove() {
      for (var i = 0; i < this.activeFilters.length; i++) {
        if (this.activeFilters[i].remove) return true
        for (var j = 0; j < this.activeFilters[i].fValues.length; j++) {
          if (this.activeFilters[i].fValues[j].remove) return true
        }
      }

      return false
    },
    onFiltersSelect(isSelected) {
      this.filtersSelected = isSelected
    },
    onAttributeSelect(isSelected) {
      this.attributesSelected = isSelected
    },
    onMarkAction(featureName, defColor, selectedRows) {
      let request = selectedRows.map(row => {
        let color = defColor
        // unmark
        if (row.color !== "") {
          color = ""
        }
        return {
          feature: featureName,
          color: color,
          value: row.value,
        }
      })
      if (request.length === 0) {
        // TODO: maybe we should show some message to user? Or mark button should be disabled in that case? 
        return Promise.resolve()
      }
      return API.AddToBlacklist(request)
    },
    toggleFold(fId, isUnfold) {
      this.activeFilters[fId].unfold = isUnfold
      this.$forceUpdate()
    },
    toggleFilter(filterId) {
      var toRemove = !this.activeFilters[filterId].remove
      this.activeFilters[filterId].remove = toRemove
      this.activeFilters[filterId].fValues.forEach(v => {
        v.remove = toRemove
      })
      this.$forceUpdate()
      this.activeFiltersSelected = this.activeFiltersToRemove()
    },
    toggleSubFilter(filterId, valueId) {
      // debugger;
      // console.log(this.activeFilters[filterId].fValues[valueId]);
      var toRemove = !this.activeFilters[filterId].fValues[valueId].remove
      this.activeFilters[filterId].fValues[valueId].remove = toRemove
      if (toRemove == false) {
        this.activeFilters[filterId].remove = toRemove
      } else {
        var removingAll = true
        for (var i = 0; i < this.activeFilters[filterId].fValues.length; i++) {
          if (!this.activeFilters[filterId].fValues[i].remove) removingAll = false
        }
        this.activeFilters[filterId].remove = removingAll
      }

      this.$forceUpdate()
      this.activeFiltersSelected = this.activeFiltersToRemove()
    },
    showFormulas() {
      this.$modal.show('formulas-view');
    },
    hideFormulas() {
      this.$modal.hide('formulas-view');
    },
    bundlesPending() {
      if (this.selectedBundles.length != this.sSelectedBundles.length) return true
      return !this.selectedBundles.every(e => this.sSelectedBundles.includes(e))
    },
    dateIsPending() {
      if (this.dates.rangeLabel != this.sDates.rangeLabel) return true
      if (this.dates.rangeLabel == "Custom range") {
        var pendingStartDate = moment(this.dates.startDate).format("YYYY-MM-DDTHH:mm:ssZ")
        var pendingEndDate = moment(this.dates.endDate).format("YYYY-MM-DDTHH:mm:ssZ")
        var currentStartDate = moment(this.sDates.startDate).format("YYYY-MM-DDTHH:mm:ssZ")
        var currentEndDate = moment(this.sDates.endDate).format("YYYY-MM-DDTHH:mm:ssZ")
        if (pendingStartDate != currentStartDate || pendingEndDate != currentEndDate) return true
      }
      return false
    },
    // refreshDates() {
    //   store.commit('refreshDates')
    // },
    updateState(state) {
      store.commit('updateState', state)
    },
    alterEvent(id) {
      store.commit('alterEvent', id)
    },
    getState(stateId) {
      return API.GetState(stateId)
        .then(response => {
          console.log(response);
          this.updateState({
            ...response.data,
            features: response.data.features,
            events: response.data.events,
          })
        })
        .catch(error => {
          console.log(error.response);
        })
    },
    StylesForEventOverview(objName) {
      return HelpersRes.StylesForEventOverview(objName)
    },
    StylesForEventSelect(objName) {
      return HelpersRes.StylesForEventSelectPresent(objName)
    },
    downloadCSVRef() {
      this.$refs.fTableComponent.downloadCSV()
    },
    applyFiltersRef() {
      this.$refs.fTableComponent.applyFilters(this.activeFilters)
      this.$refs.fTableComponent.refresh()
    },
    onPrecisionSelect(precision) {
      this.precision = precision
      this.requestChartData()
    },
    metaDataToArr(metaData) {
      var arr = []
      for (var i = 0; i < metaData.length; i++) {
        if (!metaData[i].toRemove) {
          arr.push(metaData[i].name)
        }
      }
      return arr
    },

    onApplyFilters(newFilters) {
      // this.featuresToRequest = this.createFeaturesToRequest(features)
      this.refreshDates()
      this.filter = newFilters
      API.SaveUpcomingState({
        sandbox: this.sandbox,
        precision: this.precision,
        cohort: this.cohort,
        filter: this.filter,
        dates: this.dates,
        selectedBundles: this.selectedBundles,
        formulas: this.sFormulas,
        events: this.eventsToRequest,
        features: this.featuresToRequest
      }, store.getters.getHash)
      this.requestTableData()
        .then(() => {
          return this.requestChartData()
        })
        .catch(() => {})
    },

    tableParamsFromState() {
      return {
        "sandbox": this.sandbox,
        "events": this.eventsToRequest,
        "features": this.featuresToRequest,
        "filter": {
          equal: {
            bundle_id: this.selectedBundles,
            ...this.filter,
          },
          date: {
            "start": moment(this.dates.startDate).format("YYYY-MM-DDTHH:mm:ssZ"),
            "end": moment(this.dates.endDate).format("YYYY-MM-DDTHH:mm:ssZ"),
            "cohort": this.cohort,
          }
        }
      }
    },

    chartParamsFromState() {
      return {
        "sandbox": this.sandbox,
        "precision": this.precision,
        "events": this.eventsToRequest,
        "filter": {
          equal: {
            bundle_id: this.selectedBundles,
            ...this.filter,
          },
          date: {
            "start": moment(this.dates.startDate).format("YYYY-MM-DDTHH:mm:ssZ"),
            "end": moment(this.dates.endDate).format("YYYY-MM-DDTHH:mm:ssZ"),
            "cohort": this.cohort,
          }
        }
      }
    },

    refreshState() {
      this.activeFiltersSelected = false
      this.attributesSelected = false
      this.filtersSelected = false
    },

    requestTableData() {
      this.showLoadingTable()
      var params = this.tableParamsFromState()
      return API.GetTableData(params).
      then(response => {
          //TODO: check bundles for green and blue
          if (this.selectedBundles.indexOf('app.demo.blue') != -1 && this.selectedBundles.indexOf('app.demo.green') == -1) {
            this.staticData = {
              trials: 34,
              intro: 10,
              offers: 15,
              subs: 205,
              sWeekly: 86,
              sMonthly: 110,
              sYearly: 9,
              retry: 64,
              rWeekly: 9,
              rMonthly: 55,
              rYearly: 0,
            }
          } else if (this.selectedBundles.indexOf('app.demo.blue') == -1 && this.selectedBundles.indexOf('app.demo.green') != -1) {
            this.staticData = {
              trials: 20,
              intro: 7,
              offers: 8,
              subs: 180,
              sWeekly: 57,
              sMonthly: 114,
              sYearly: 9,
              retry: 54,
              rWeekly: 7,
              rMonthly: 47,
              rYearly: 0,
            }
          } else if (this.selectedBundles.indexOf('app.demo.blue') == -1 && this.selectedBundles.indexOf('app.demo.green') == -1) {
            this.staticData = {
              trials: 0,
              intro: 0,
              offers: 0,
              subs: 0,
              sWeekly: 0,
              sMonthly: 0,
              sYearly: 0,
              retry: 0,
              rWeekly: 0,
              rMonthly: 0,
              rYearly: 0,
            }
          } else {
            this.staticData = {
              trials: 54,
              intro: 17,
              offers: 23,
              subs: 385,
              sWeekly: 143,
              sMonthly: 224,
              sYearly: 18,
              retry: 118,
              rWeekly: 16,
              rMonthly: 102,
              rYearly: 0,
            }
          }
          //
          this.refreshState()
          this.updateState({
            cohort: this.cohort,
            dates: this.dates,
            sandbox: this.sandbox,
            selectedBundles: this.selectedBundles,
            filter: this.filter,
            data: response.data.features,
          })
          this.hideLoadingTable()
        })
        .catch(error => {
          this.hideLoadingTable()
          console.log(error.response);
        })
    },
    requestChartData() {
      this.showLoadingChart()
      var params = this.chartParamsFromState()
      return API.GetChartData(params).
      then(response => {
          this.refreshState()
          this.updateState({
            precision: this.precision,
            //TODO: save chart data in store same as table data
          })
          this.createChartData(response.data.events)
          this.hideLoadingChart()
        })
        .catch(error => {
          this.hideLoadingChart()
          console.log(error.response);
        })
    },
    showLoadingTable() {
      this.loadingTable = true
    },
    hideLoadingTable() {
      this.loadingTable = false
    },
    showLoadingChart() {
      this.loadingChart = true
    },
    hideLoadingChart() {
      this.loadingChart = false
    },
    createChartData(data) {
      let eventNames = Object.keys(data).filter(e => e !== "");
      var chartIndexByEventName = {}
      var chartData = [
        []
      ]
      chartData[0] = ["Date"]

      for (var i = 0; i < eventNames.length; i++) {
        chartData[0].push(eventNames[i])
        chartIndexByEventName[eventNames[i]] = i + 1
      }

      let chartHeaderLength = chartData[0].length
      var concatenated = []
      for (i = 1; i < chartHeaderLength; i++) {
        concatenated = concatenated.concat(data[chartData[0][i]])
      }
      let dformat = this.dateFormatter()
      concatenated = concatenated.map(obj => {
        obj.date = dformat(obj.date)
        return obj
      });
      concatenated.sort(this.byStringDates)


      concatenated.forEach(function(event) {
        let eventIndex = chartIndexByEventName[event.event]
        // th.createEventsGroup(event, eventIndex)

        // event.date = event.date.substring(0, event.date.indexOf('T'));
        if (event.date == chartData[chartData.length - 1][0]) {
          chartData[chartData.length - 1][eventIndex] = event.count
          return
        }

        var row = [event.date]
        for (var i = 1; i < chartHeaderLength; i++) {
          if (i == eventIndex) {
            row.push(event.count)
          } else {
            row.push(0)
          }
        }

        chartData.push(row)
      })

      var colors = []
      for (var eventNameID = 1; eventNameID < chartData[0].length; eventNameID++) {
        colors.push(HelpersRes.StylesForEventOverview(chartData[0][eventNameID]))
      }
      this.chartOptions.colors = colors
      this.chartData = chartData
      this.backupChartData = chartData.map(function(arr) {
        return arr.slice();
      });
      this.createEventsGroup()
    },

    dateFormatter() {
      let momnt = moment
      let format = "YYYY-MM-DDThh:mm:ss"
      switch (this.precision) {
        case "year":
          format = "YYYY"
          break;
        case "month":
          format = "YYYY-MM"
          break;
        case "week":
        case "day":
          format = "YYYY-MM-DD"
          break;
        case "hour":
          format = "HH:mm"
          break;
        case "minute":
          format = "HH:mm"
          break;
        default:
      }

      return function(date) {
        return momnt(date, "YYYY-MM-DDTHH:mm:ss").format(format)
      }
    },

    createEventsGroup() {
      this.eventsGroup = {}
      this.events.filter(event => event.isPresent).forEach(event => {
        this.eventsGroup[event.name] = {
          name: event.name,
          shown: true
        }
      })
    },

    filterChart() {
      for (var i = 1; i < this.backupChartData[0].length; i++) {
        let shown = this.eventsGroup[this.backupChartData[0][i]].shown
        for (var j = 1; j < this.backupChartData.length; j++) {
          if (shown) {
            this.chartData[j][i] = this.backupChartData[j][i]
          } else {
            this.chartData[j][i] = 0
          }
        }
      }
      this.chartData.push(this.chartData[this.chartData.length - 1])
      this.chartData.splice(-1, 1)
    },

    byStringDates(a, b) {
      if (a.date < b.date) {
        return -1;
      }
      if (a.date > b.date) {
        return 1;
      }
      return 0;
    }
  }
}
</script>

<style src="vue2-daterange-picker/dist/vue2-daterange-picker.css">

</style>
<style lang="scss">
@import '../assets/variables.scss';

#overview {
    .small_screens {
        display: none;
    }

    button {
        outline: none;
    }

    .modal-loader {
        .v--modal-box {
            z-index: 500;
            background-color: transparent !important;
            display: table-cell;
            text-align: center;
            vertical-align: middle;
        }
    }

    .formulasModal {
        display: flex;
        flex-direction: column;
        border-radius: 5px;
        background-color: white !important;
    }

    .select-line1 {
        width: 100%;
        padding: 15px;
        box-sizing: border-box;
        display: flex;
        justify-content: end;
        align-items: center;
        background-color: white;
        .s-bundles {
            display: flex;
            flex-direction: row;
            margin-right: 20px;
            position: relative;
            align-items: center;

            .bundle-info {
                opacity: 0;
                visibility: hidden;

                text-align: left;
                padding: 7px;
                white-space: nowrap;
                font-size: 13px;
                position: absolute;
                z-index: 10;
                background-color: white;
                top: 100%;
                border: 1px solid #EDEDED;
                border-radius: 4px;
                // margin-left: -100px;
                display: flex;
                flex-direction: column;
                &.show {
                    opacity: 1;
                    visibility: visible;
                }
                i {
                    color: $newBlue;
                    &:hover {
                        cursor: pointer;
                    }
                }
            }
            .bundle {
                margin-right: 3px;
                margin-left: 3px;
                height: auto;
                .applogo {
                    border: 1px solid #e8e8e8;
                    border-radius: 2px;
                    width: 40px;
                    vertical-align: middle;
                    &:hover {
                        cursor: pointer;
                    }
                }
                &.active {
                    margin-right: 1px;
                    margin-left: 1px;
                    border: 4px solid orange;
                    border-radius: 6px;
                    width: 38px;
                    height: 38px;
                    .applogo {
                        width: 38px;
                        border: none;
                        border-radius: none;
                    }
                }
            }
        }

        .static_wrap {
            display: flex;
            flex-direction: column;
            text-align: left;
            overflow-x: scroll;
            width: 100%;
            .static_loading {
                height: 90px;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                background: rgba(0, 0, 0, 0.2);
            }
            .stats {
                font-weight: bold;
                margin-top: 14px;
                margin-left: 10px;
            }
            .static_data {
                display: flex;
                flex-direction: row;
                margin: 5px 0;
                justify-content: left;
                .static {
                    margin-right: 10px;
                    height: 70px;
                    background: rgba(37, 176, 255, 0.08);
                    border-radius: 8px;

                    text-align: left;
                    border: 1px solid #e4edf4;
                    box-sizing: border-box;
                    box-shadow: 0 2px 4px #e9f0f5;
                    border-radius: 8px;
                    padding: 10px;
                    margin-top: 10px;
                    position: relative;
                    display: flex;
                    flex-direction: row;
                    &.last {
                        margin-right: 0;
                    }
                    .static_pair {
                        display: flex;
                        flex-direction: column;
                        margin: 5px;
                        .static_subs {
                            white-space: nowrap;
                            font-size: 14px;
                            line-height: 16px;
                            .number {
                                color: $newBlue;
                                font-weight: bold;
                            }
                        }
                    }
                    .static_header {
                        white-space: nowrap;
                        font-style: normal;
                        font-weight: normal;
                        font-size: 14px;
                        line-height: 16px;
                        vertical-align: middle;
                        .fa-question {
                            display: none;
                            &:hover {
                                cursor: pointer;
                                .tooltiptext {
                                    visibility: visible;
                                }
                            }
                            font-size: 8px;
                            position: relative;

                            /* Tooltip text */
                            .tooltiptext {
                                display: block;
                                padding: 6px 8px;
                                font-size: 12px;
                                visibility: hidden;
                                width: 120px;
                                background-color: black;
                                color: #fff;
                                text-align: center;
                                border-radius: 6px;

                                /* Position the tooltip text - see examples below! */
                                position: absolute;
                                z-index: 1;
                            }
                        }
                    }
                    .static_number {
                        text-align: center;
                        font-weight: 900;
                        font-size: 25px;
                        line-height: 29px;
                        color: $newBlue;
                    }
                }
            }
        }
    }

    .select-line2 {
        padding: 0 15px;
        box-sizing: border-box;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        background-color: white;
        z-index: 9999;
        border-top: 1px solid #EDEDED;
        border-bottom: 1px solid #EDEDED;
        margin-bottom: 10px;
        &.sticky {
            position: fixed;
            top: 0;
            width: 100%;
        }
        .s-events-wrap {
            margin-left: 20px;
            display: flex;
            align-items: center;
            .events-label {
                font-weight: bold;
                font-size: 15px;
                margin-right: 3px;
            }
        }

        .btn-icon {
            border: none;
            background-color: inherit;
            color: $newBlue;
            border: 1px solid $newBlue;
            border-radius: 4px;
            font-size: 14px;
            line-height: 16px;
            padding: 5px;
            margin-right: 7px;
            &:hover {
                cursor: pointer;
            }
            &.disabled {
                color: gray;
                border-color: gray;
            }
        }

        .select-events {
            width: 500px;
        }

        .dates {
            margin-left: 40px;
            .vue-daterange-picker {
                .form-control {
                    border-radius: 5px;
                    border: 1px solid #e8e8e8;
                    height: 28px;
                    // border: none !important;
                }
                // &.pending > .form-control {
                //     border-color: $darkBlue;
                // }
                // &.pending > .reportrange-text > i,
                // &.pending > .reportrange-text > span {
                //     color: $darkBlue;
                // }
                // .reportrange-text > i,
                // .reportrange-text > span {
                //     color: $darkGreen;
                // }
            }
            .fa-calendar-alt {
                position: absolute;
                left: 11px;
                color: $newBlue;
            }
            *:focus {
                outline: none;
            }
            .dropdown-wrapper {
                // width: 140px;
                // height: 22px;
                // display: none;
            }
            .glyphicon-calendar {
                display: none;
            }
            .reportrange-text {
                display: flex;
                align-items: center;
                padding: 0 20px 0 27px;
                justify-content: center;
                font-weight: bold;
                // min-width: 140px;
                font-size: 13.5px;
                box-sizing: border-box;
                width: 218px;
                padding-right: 10px;
            }
            .daterangepicker {
                margin-top: 15px;
                .calendars {
                    display: flex;
                    .row.mx-1 {
                        display: flex;
                        .monthselect {
                            cursor: pointer;
                        }
                        .yearselect.col {
                            flex-basis: 0;
                            flex-grow: 1;
                            position: relative;
                            width: 100%;
                            padding-left: 15px;
                        }
                    }
                }
            }
        }

        .select-cohort {
            margin-left: 20px;
        }

        .apply-container {
            height: 47px;
            display: flex;
            flex: 1;
            .btn-apply {
                margin: auto 40px auto auto;
                border: none;
                width: 90px;
                height: 35px;
                background-color: $newBlue;
                border-radius: 7px;
                font-size: 15px;
                font-weight: 700;
                color: #ffffff;
                letter-spacing: 1px;
                text-decoration: none;
                transition: background-color 0.2s;
                text-align: center;
                cursor: pointer;
                &:hover {
                    background-color: lighten($newBlue,5%);
                }
                &.pending {
                    background-color: $newOrange;
                    &:hover {
                        background-color: lighten($newOrange,5%);
                    }
                }
            }
        }
    }

    .select-bar {
        // background-color: #f4ecdc;
        background-color: white;
        z-index: 9999;
        // position: fixed;
        top: 0;
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 5px 7px;
        box-sizing: border-box;
        -webkit-box-shadow: 0 4px 6px -6px #222;
        -moz-box-shadow: 0 4px 6px -6px #222;
        box-shadow: 0 4px 6px -6px #222;

        .select-project {
            max-width: 140px;
            .multiselect__tags-wrap {
                display: flex;
                overflow-x: scroll;
            }

            .multiselect__tags {
                padding-top: 5px;
                padding-left: 5px;
                height: 52px;
                padding-bottom: 2px;
                padding-right: 25px;

                .multiselect__single {
                    margin-bottom: 0;
                }
            }

            .multiselect__option--highlight {
                background: $darkBlue;
            }
            .multiselect__option--selected.multiselect__option--highlight {
                background: #ff6a6a;
            }

            // &.pending .multiselect__tags {
            //     border-color: $darkBlue;
            // }

            .applogo-container {
                position: relative;
                max-height: 40px;

                .applogo {
                    border: 1px solid #e8e8e8;
                    border-radius: 4px;
                }

                .remove {
                    position: absolute;
                    display: table;
                    top: 0;
                    left: 0;
                    width: 40px;
                    height: 40px;
                    color: #FFF;
                    border-radius: 4px;

                    .cross {
                        display: none;
                        vertical-align: middle;
                        text-align: center;
                        z-index: 999;
                    }

                    &:hover {
                        cursor: pointer;
                        background: rgba(0, 0, 0, .6);

                        .cross {
                            display: table-cell;
                        }
                    }
                }
            }

            .inline {
                display: inline-flex;
                align-items: center;
                padding: 5px;
            }

            .multiselect__select {
                padding-left: 0;
                padding-right: 0;
                width: 30px;
            }

            .multiselect__content-wrapper {
                min-width: 200px;
                .multiselect__content {
                    padding: 0;
                    .multiselect__option {
                        padding: 0;
                        margin: 0;
                        font-size: 14px;
                    }
                }
            }
        }

        .divider {
            min-width: calc(100% + 14px);
            // height: 1px;
            flex-basis: 100%;
            margin-top: 4px;
            margin-bottom: 4px;
            margin-left: -7px;
            // margin: 4px 0 4px -7px;
            border-top: 1px solid #EDEDED;
        }
        .btn-icon {
            border: none;
            background-color: inherit;
            color: $newBlue;
            border: 1px solid $newBlue;
            border-radius: 4px;
            font-size: 14px;
            line-height: 16px;
            padding: 5px;
            margin-right: 7px;
            &:hover {
                cursor: pointer;
            }
        }

        .filters-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            .btn-icon {
                border: none;
                background-color: inherit;
                &:hover {
                    cursor: pointer;
                }
            }
            .filters-label {
                margin-left: 95px;
                font-weight: bold;
                margin-right: 10px;
            }
            .filter {
                display: inline;
                position: relative;
                display: inline-block;
                padding: 4px 16px 4px 0;
                border-radius: 5px;
                margin-right: 6px;
                color: #fff;
                line-height: 1;
                background: white;
                color: darken($greenSelect,10%);
                font-weight: bold;
                white-space: nowrap;
                max-width: 100%;
                text-overflow: ellipsis;
                overflow: visible;
                user-select: none;
                .pending {
                    color: $darkBlue;
                }
                &:hover {
                    cursor: pointer;
                }

                &.removing {
                    color: $darkBlue;
                    .filter-icon:after {
                        content: "+";
                    }
                }

                .filter-icon {
                    cursor: pointer;
                    margin-left: 2px;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    font-weight: 700;
                    font-style: normal;
                    width: 15px;
                    text-align: center;
                    -webkit-transition: all 0.2s ease;
                    transition: all 0.2s ease;
                    border-radius: 5px;
                    outline: none;
                    &:hover {
                        background-color: darken(#41b883,7%);
                    }
                }
                .filter-icon:after {
                    content: "\D7";
                    color: #266d4d;
                    font-size: 17px;
                }
                .filter-icon:hover:after {
                    color: white;
                }
                .fake-margin {
                    position: absolute;
                    height: 15px;
                    width: 100%;
                }
                // .dropdown {
                //     position: absolute;
                //     background-color: white;
                //     margin-top: 0.45em;
                //     border-radius: 0.35em;
                //     list-style-type: none;
                //     z-index: 9999;
                //     padding: 6px 7px 2px;
                //     text-align: left;
                //     left: -4px;
                //     font-weight: normal;
                //     box-shadow: 0 0 3px #ccc;
                // 
                //     visibility: hidden;
                //     opacity: 0;
                //     transition: all 200ms linear;
                // 
                //     &.show {
                //         visibility: visible;
                //         opacity: 1;
                //     }
                //     .subfilter {
                //         margin-bottom: 4px;
                //         display: flex;
                //         justify-content: space-between;
                //         &.removing {
                //             color: $darkBlue;
                //         }
                //         &.removing {
                //             .filter-icon:after {
                //                 content: "+";
                //             }
                //         }
                //     }
                // }
            }
        }

    }

    .chart-wrapper {
        position: relative;
        display: flex;
        flex-direction: row;
        width: 100%;
        min-height: 400px;
        // width: 100px;
        // height: 100px;
        margin-top: 10px;
        padding: 0 10px;
        box-sizing: border-box;
        align-items: flex-start;
        .chart-events {
            // height: calc(100vh - 30px);
            // height: 90%;
            height: calc(100vh - 53px);
        }

        .chart-settings {
            padding: 10px;
            width: 17%;
            background: #FFFFFF;
            border: 1px solid #EDEDED;
            box-sizing: border-box;
            border-radius: 3px;
            margin-right: 8px;

            .select-precision-wrap {
                margin-top: 20px;
                display: flex;
                flex-direction: column;
                text-align: left;
                span {
                    font-weight: bold;
                    margin-bottom: 10px;
                }

                .select-precision {
                    width: 180px;
                }
            }

            .event-checkbox {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 190px;
                input {
                    width: 20px;
                    height: 20px;
                    margin-right: 15px;
                }

                .circle {
                    width: 16px;
                    height: 16px;
                    border-radius: 8px;
                    margin-right: 5px;
                }
            }
        }

        .charts {
            width: 100%;
            height: calc(100vh - 71px);
            border: 1px solid #EDEDED;
            box-sizing: border-box;
            border-radius: 3px;
        }
    }

    .leave_email {
        margin: 30px 10px 10px;
        padding: 20px;
        box-sizing: border-box;
        background-color: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 200px;
        align-items: center;
        // width: 100%;

        .get_in_touch {
            font-weight: bold;
        }

        min-width: 300px;
        input {
            min-width: 300px;
            box-sizing: border-box;
        }

        .submit_email {
            cursor: pointer;
            width: 300px;
        }
    }

    @media (max-width:1250px) {
        .small_screens {
            padding-top: 20px;
            display: block;
            font-weight: bold;
        }
        .big_screens {
            display: none;
        }
    }
}
</style>
